export default __webpack_public_path__ + "static/media/meetJonas_cropped.803c8029.jpg";